module.exports = __webpack_public_path__ + "static/media/pizzahutbg.7b99fa5f.png";